import Resources from "../../shared/actions/resourcesActions";

export default class ObserverResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "observer", "/api/v1/observers");
    this.refreshPageContentAfterCommit = true;
  }
}
